import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as n } from "react";
const r = ({
  title: l,
  titleId: o,
  ...i
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...i,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M214.948 348.681h590.304c24.439 0 44.277-19.892 44.277-44.424 0-24.481-19.838-44.373-44.277-44.373H214.948c-24.464 0-44.277 19.892-44.277 44.373 0 24.531 19.813 44.424 44.277 44.424M805.24 471.444H214.936c-24.439 0-44.251 19.867-44.251 44.399 0 24.506 19.813 44.373 44.251 44.373H805.24c24.464 0 44.302-19.867 44.302-44.373 0-24.531-19.838-44.399-44.302-44.399m0 211.57H214.936c-24.439 0-44.251 19.867-44.251 44.399 0 24.506 19.813 44.373 44.251 44.373H805.24c24.464 0 44.302-19.867 44.302-44.373 0-24.531-19.838-44.399-44.302-44.399",
          clipRule: "evenodd"
        }
      )
    ]
  }
), s = n(r);
export {
  s as default
};
